import { styled } from "@mui/styles";
import { Box } from "@mui/material";

export const StyledInput = styled(Box)(({ theme }) => ({
    '& .currency-box-out': {
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
        width: '45%'
    },
    '& .currency-box-inn-area': {
        border: 'solid #C1C1C1',
        height: '40px',
        borderWidth: '1px 0 1px 1px',
        [theme.breakpoints.down('sm')]: {
            borderWidth: '1px 1px 0 1px',
        },
    },
    '& .MuiInputBase-root': {
        borderRadius: 0,
        '& input': {
            textAlign: 'right',
            paddingLeft: '9px',
            marginRight: '-5px',
            color: theme.palette.neutral.main,
        }
    },
    '& .MuiInputAdornment-root p': {
        marginTop: '2px'
    },
    '& .MuiFormHelperText-root': {
        textAlign: 'end'
    }
}));